import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, toObservable, nullsafe } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { Argumentos, ArgumentosComponent, Props } from "./argumento"
import { SolucionesRuta } from "app/features/componentes/enrutamiento/solucionesRuta";

class EnrutamientoControlled extends React.PureComponent<Props> {
    value = (props: Props) => props.value || {};
    ruta = createSelectorRx(this.value, x =>
        (x.idSucursalOrigen && x.idSucursalDestino) ?
            observeResource(resources.Logistica.Enrutar, x.idSucursalOrigen, x.idSucursalDestino, x.idRutaOrigen) : toObservable<null>(null));

    render() {
        const ruta = this.ruta(this.props);
        return (
            <div>
                <kea.Title titulo="Enrutamiento" onLimpiar={() => { this.props.onChange({} as any) }} />
                <ArgumentosComponent {... this.props} />
                <SolucionesRuta value={ruta} idRutaOrigen={nullsafe(this.props.value, x => x.idRutaOrigen)} />
            </div>
        )
    }
}

export const Enrutamiento = kea.defaultProps(kea.makeUncontrolledCookies<Props>("value", "onChange")(EnrutamientoControlled), { cookieKey: "enrutamiento" });


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/enrutamiento/index.tsx